import classNames from "classnames";
import { HTMLAttributes, useEffect, useRef } from "react";

import { useIsMobileWidth } from "src/hooks/window";
import { StyledPanelBody } from "../Panel.styled";
import { resizePanel } from "../utils";

type Props = HTMLAttributes<HTMLDivElement> & {
  /**
   * Set panel to be full height (to the bottom of page)
   */
  fullHeight?: boolean;

  /**
   * Set panel to be full height (to the bottom of page) (for panel with footer only)
   */
  fullHeightWithFooter?: boolean;
};

const defaultProps = {
  fullHeight: false,
  fullHeightWithFooter: false
};

// eslint-disable-next-line no-unused-vars
const PanelBody = (props: Props) => {
  const { children, className, fullHeight, fullHeightWithFooter } = props;

  const panelBodyRef = useRef(null);
  const panelBodyClass = classNames("c-panel__body", className);
  const isMobileWidth = useIsMobileWidth();

  useEffect(() => {
    if (fullHeight || fullHeightWithFooter) resizePanel(panelBodyRef, fullHeightWithFooter, isMobileWidth);
  }, [isMobileWidth, panelBodyRef.current, fullHeightWithFooter, fullHeight]);

  return (
    <StyledPanelBody ref={panelBodyRef} data-testid="qa-panel-body" className={panelBodyClass}>
      {children}
    </StyledPanelBody>
  );
};

PanelBody.defaultProps = defaultProps;

export default PanelBody;
